// extracted by css-extract-rspack-plugin
export default {"root":"GridHeaderRow_root__Sgjhg","borderBottom":"GridHeaderRow_borderBottom__uA9Ni"};